import { UntypedFormControl } from '@angular/forms';

export function validateEuropeanDomain(formControl: UntypedFormControl) {

	const regEx = new RegExp('\\^*\\.(nl|be|de|fr|it|eu|es|li|md|no|gr|bg|pl|fi|dk|hu|lu|mt|pt|se|cz|ie|uk|at|cy|hr|ee|lv|lt|ro|sk|si|ch|is)$');

	if (regEx.test(formControl.value)) {
		return {
			europeanDomain: true
		};
	}

	return null;
}
